import { render, staticRenderFns } from "./AdminLayout.vue?vue&type=template&id=67288acd&scoped=true"
import script from "./AdminLayout.vue?vue&type=script&lang=js"
export * from "./AdminLayout.vue?vue&type=script&lang=js"
import style0 from "./AdminLayout.vue?vue&type=style&index=0&id=67288acd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67288acd",
  null
  
)

export default component.exports